import classNames from "classnames";
import { BOLD_TEXT, SIZE_TEXT } from "../features/foundation";

type TextProps = {
    children?: React.ReactNode;
    href?: string;
    underline?: boolean;
    className?: string;
    cursor?: "pointer";
    size?: keyof typeof SIZE_TEXT;
    bold?: keyof typeof BOLD_TEXT;
    as?: "link";
    onClick?: (...arg: any) => void;
};

// fontSize: {
//     xs: "11px",
//     sm: "12px",
//     base: "13px",
//     lg: "14px",
//     xl: "16px",
//     "2xl": "18px",
//     "3xl": "20px",
// },

export const Text = (props: TextProps) => {
    const { children, href, className, size, bold, underline, cursor, onClick, as } = props;

    if (href)
        return (
            <a
                href={href}
                className={classNames(
                    "text-blue underline w-fit",
                    size && SIZE_TEXT[size],
                    bold && BOLD_TEXT[bold],
                    as && "underline text-blue",
                    className,
                )}
                onClick={onClick}
            >
                {children}
            </a>
        );

    return (
        <span
            className={classNames(
                "w-fit",
                size && SIZE_TEXT[size],
                bold && BOLD_TEXT[bold],
                underline && "underline",
                cursor === "pointer" && "cursor-pointer",
                as && "underline text-blue",
                className,
            )}
            onClick={onClick}
        >
            {children}
        </span>
    );
};
